import { i18n } from '@/plugins/i18n'

export const shRequestType = {
    NEW_TERMINAL:5,
    CHANGE_TERMINAL_SHEBA:6,
    DISABLE_TERMINAL:7,
    REGISTER_MERCHANT_AND_SHOP:13,
    EDIT_INFO:14,
    CHANGE_SHOP_LOCATION:17,
    ENABLE_TERMINAL:18,
}

export const shRequestTypeStr = {
    NEW_TERMINAL:i18n.t('sh_request_type.new_terminal'),
    CHANGE_TERMINAL_SHEBA:i18n.t('sh_request_type.change_terminal_sheba'),
    DISABLE_TERMINAL:i18n.t('sh_request_type.disable_terminal'),
    REGISTER_MERCHANT_AND_SHOP:i18n.t('sh_request_type.register_merchant_and_shop'),
    EDIT_INFO:i18n.t('sh_request_type.edit_info'),
    CHANGE_SHOP_LOCATION:i18n.t('sh_request_type.change_shop_location'),
    ENABLE_TERMINAL:i18n.t('sh_request_type.enable_terminal'),
    get(type) {
        let type_str = null;
        Object.keys(shRequestType).forEach(function (item) {
            if(shRequestType[item] === type) {
                type_str = shRequestTypeStr[item]
            }
        })

        return type_str
    }
}